import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between mb-4" }
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = { class: "bg-white rounded-lg border border-gray-300" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.$t("stats.course.sidebar.quiz")), 1),
      _createVNode(_component_Button, {
        label: _ctx.$t('labels.generic', { pt: 'Baixar', en: 'Download' }),
        icon: "pi pi-download",
        class: "p-button-sm btn-primary h-9",
        loading: _ctx.btnLoading,
        onClick: _ctx.downloadCSV
      }, null, 8, ["label", "loading", "onClick"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Table, {
        slotData: _ctx.quiz,
        columns: _ctx.columns,
        hasActions: false,
        loading: _ctx.loading,
        filters: _ctx.filters,
        params: _ctx.params,
        hasStatus: true,
        onOnFilter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.filterFor())),
        onOnPaginate: _cache[2] || (_cache[2] = ($event: any) => (_ctx.paginate($event))),
        onOnClearFilter: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clearFilter())),
        onOnToggleFilter: _cache[4] || (_cache[4] = (e, type) => _ctx.toggleFilter(e, type))
      }, {
        filters: _withCtx(() => [
          (_ctx.filterType == 'learningObjectiveName')
            ? (_openBlock(), _createBlock(_component_InputText, {
                key: 0,
                modelValue: _ctx.filters.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.name) = $event))
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["slotData", "columns", "loading", "filters", "params"])
    ])
  ]))
}